import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Form,
  FormGroup,
  FormField
} from 'semantic-ui-react'

const CardPhysicalExamUX = (props: any) => {
    return(
      <div>
        <div
          id="CardPhysicalExamUX-div-1"
          style={{ fontWeight: "bold", fontSize: "15px" }}>
          {props.languageUX === "en" ? "Physical examination information" : "ข้อมูลการตรวจร่างกาย"}
        </div>
        <div
          id="CardPhysicalExamUX-div-2"
          style={{ padding: "20px" }}>
          
          <div
            id="CardPhysicalExamUX-div-4">
            {props.organList}
          </div>
        </div>
        <div
          id="CardPhysicalExamUX-div-3">
          
          <Form
            id="CardPhysicalExamUX-Form-7">
            <FormGroup
              id="CardPhysicalExamUX-FormGroup-8">
              <FormField
                id="CardPhysicalExamUX-FormField-9"
                width={2}>
                <label
                  id="CardPhysicalExamUX-label-5">
                  {props.languageUX === "en" ? "Template" : "Template"}
                </label>
              </FormField>
              <FormField
                id="CardPhysicalExamUX-FormField-10"
                width={14}>
                <div
                  id="CardPhysicalExamUX-div-16">
                  {props.templateDropdown}
                </div>
              </FormField>
            </FormGroup>
          </Form>
        </div>
        <div
          id="CardPhysicalExamUX-div-11">
          
          <div
            id="CardPhysicalExamUX-div-12">
            {props.templateItem}
          </div>
        </div>
        <div
          id="CardPhysicalExamUX-div-13">
          
          <Form
            id="CardPhysicalExamUX-Form-14">
            <div
              id="CardPhysicalExamUX-div-17">
              {props.otherDetailText}
            </div>
          </Form>
        </div>
      </div>
    )
}


export default CardPhysicalExamUX

export const screenPropsDefault = {}

/* Date Time : Thu Nov 20 2025 07:17:10 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": "ข้อมูลการตรวจร่างกาย",
          "valueEN": "Physical examination information"
        },
        "id": {
          "type": "value",
          "value": "CardPhysicalExamUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", fontSize: \"15px\" }"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPhysicalExamUX-div-2"
        },
        "style": {
          "type": "code",
          "value": "{ padding: \"20px\" }"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPhysicalExamUX-div-3"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "code",
          "value": "props.organList"
        },
        "id": {
          "type": "value",
          "value": "CardPhysicalExamUX-div-4"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": null,
      "id": 5,
      "name": "label",
      "parent": 9,
      "props": {
        "children": {
          "type": "value",
          "value": "Template",
          "valueEN": "Template"
        },
        "id": {
          "type": "value",
          "value": "CardPhysicalExamUX-label-5"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 7,
      "name": "Form",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPhysicalExamUX-Form-7"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 8,
      "name": "FormGroup",
      "parent": 7,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPhysicalExamUX-FormGroup-8"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 9,
      "name": "FormField",
      "parent": 8,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPhysicalExamUX-FormField-9"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 10,
      "name": "FormField",
      "parent": 8,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPhysicalExamUX-FormField-10"
        },
        "width": {
          "type": "code",
          "value": "14"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": null,
      "id": 11,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPhysicalExamUX-div-11"
        },
        "style": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": null,
      "id": 12,
      "name": "div",
      "parent": 11,
      "props": {
        "children": {
          "type": "code",
          "value": "props.templateItem"
        },
        "id": {
          "type": "value",
          "value": "CardPhysicalExamUX-div-12"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": null,
      "id": 13,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPhysicalExamUX-div-13"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 14,
      "name": "Form",
      "parent": 13,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPhysicalExamUX-Form-14"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": null,
      "id": 16,
      "name": "div",
      "parent": 10,
      "props": {
        "children": {
          "type": "code",
          "value": "props.templateDropdown"
        },
        "id": {
          "type": "value",
          "value": "CardPhysicalExamUX-div-16"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": null,
      "id": 17,
      "name": "div",
      "parent": 14,
      "props": {
        "children": {
          "type": "code",
          "value": "props.otherDetailText"
        },
        "id": {
          "type": "value",
          "value": "CardPhysicalExamUX-div-17"
        }
      },
      "seq": 17,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "name": "CardPhysicalExamUX",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
